import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function ReplaceTierDialog({ pending, currentLabel, newLabel, onConfirm, onCancel }) {
  return (
    <AlertDialog open={!!pending} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent className="bg-[#0A0A0A] border border-[#CCFF00] text-white rounded-none" data-testid="replace-tier-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">Replace tier?</AlertDialogTitle>
          <AlertDialogDescription className="text-[#A3A3A3]" data-testid="replace-tier-message">
            You already have a tier selected. Replace it with this one?
            {currentLabel && newLabel && (
              <span className="block mt-2 text-xs text-[#525252]">{currentLabel} → <span className="text-[#CCFF00]">{newLabel}</span></span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="replace-tier-cancel"
            className="rounded-none bg-transparent border-[#525252] text-[#A3A3A3] hover:bg-transparent hover:text-white hover:border-white">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="replace-tier-confirm"
            className="rounded-none bg-[#CCFF00] text-black font-bold hover:bg-[#b8e600]">
            Replace
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
